(function () {
  function updateSepararEnvios(checked) {
    var value = checked ? 'Si' : '';

    console.log('[separar-envios] update ->', value);

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { separar_envios: value } })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      console.log('[separar-envios] /cart/update.js OK ->', data.attributes);
      return data;
    });
  }

  // Delegación: funciona aunque el mini-cart se re-renderice 100 veces
  document.addEventListener('change', function (e) {
    var el = e.target;

    // Si el input es exactamente el checkbox o viene desde dentro de un label
    if (!el) return;

    // OJO: si el target no es el input, intenta encontrarlo
    var cb = null;

    if (el.classList && el.classList.contains('js-separar-envios')) {
      cb = el;
    } else if (el.closest) {
      cb = el.closest('.js-separar-envios');
    }

    if (!cb) return;

    updateSepararEnvios(cb.checked)
      .then(function () {
        // Trae cart actualizado y pide al tema refrescar el drawer si lo soporta
        return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        console.log('[separar-envios] cart.js ->', cart.attributes);

        // Evento típico que muchos temas escuchan
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: cart, openMiniCart: true }
          })
        );

        // Fallback: si tu tema no escucha cart:refresh, al menos el atributo ya queda guardado
      })
      .catch(function (err) {
        console.log('[separar-envios] ERROR', err);
      });
  }, true); // <- CAPTURE TRUE para que nadie “mate” el evento antes
    async function bohemikSyncPrepAttributes() {
    // 1) Lee el carrito real
    const cart = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(r => r.json());

    // 2) Arma detalle por producto desde properties["Tiempo de preparación"]
    let maxPrep = 1;
    const lines = [];

    for (const item of (cart.items || [])) {
      const props = item.properties || {};
      const prepText = props['Tiempo de preparación']; // debe existir si lo guardaste en add-to-cart

      if (!prepText) continue;

      const m = String(prepText).match(/(\d+)/);
      const n = m ? parseInt(m[1], 10) : 1;

      if (!Number.isNaN(n) && n > maxPrep) maxPrep = n;

      const qty = item.quantity ? ` x${item.quantity}` : '';
      lines.push(`• ${item.product_title}${qty}: ${prepText}`);
    }

    const nextMax = String(maxPrep);
    const nextDet = lines.join('\n');

    const currentMax = cart.attributes && cart.attributes.prep_max ? String(cart.attributes.prep_max) : '';
    const currentDet = cart.attributes && cart.attributes.prep_detalle ? String(cart.attributes.prep_detalle) : '';

    // Evita POST innecesario
    if (currentMax === nextMax && currentDet === nextDet) return cart;

    // 3) Guarda atributos para que aparezcan en Admin (Información adicional)
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          prep_max: nextMax,
          prep_detalle: nextDet
        }
      })
    }).then(r => r.json());

    console.log('[prep] /cart/update.js OK ->', res.attributes);
    return res;
  }

  // Antes de ir a checkout, sincroniza prep_max y prep_detalle
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form) return;

    const action = (form.getAttribute('action') || '').toLowerCase();
    const isCartForm = action.includes('/cart');
    const submitter = e.submitter;

    if (!isCartForm || !submitter) return;

    const name = (submitter.getAttribute('name') || '').toLowerCase();
    if (name !== 'checkout') return;

    e.preventDefault();

    bohemikSyncPrepAttributes()
      .catch(function (err) { console.log('[prep] ERROR', err); })
      .finally(function () { form.submit(); });
  }, true);

  // Opcional: al cargar página, intenta sincronizar sin bloquear
  document.addEventListener('DOMContentLoaded', function () {
    bohemikSyncPrepAttributes().catch(function () {});
  });
})();